const PROJECT_STATUS_OPTIONS = [
    { label: 'PENDING', color: '#F4C067' }, // Warm Beige Yellow
    { label: 'ONGOING', color: '#4A90E2' }, // Muted Sky Blue
    { label: 'COMPLETED', color: '#7DCFB6' }, // Soft Sage Green
    { label: 'CANCELLED', color: '#E07A5F' }, // Subtle Terracotta Red
]

export default  PROJECT_STATUS_OPTIONS;